import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import KollabTextViewer from './KollabTextViewer';
import type {
  KollabTextViewerProps,
  KollabTextViewerAPI,
  KollabTextViewerHandle,
} from './types';

declare global {
  interface Window {
    mountKollabTextViewer: (
      containerId: string,
      props: KollabTextViewerProps,
    ) => KollabTextViewerHandle;
  }
}

window.mountKollabTextViewer = function mountKollabTextViewer(
  containerId: string,
  props: KollabTextViewerProps,
): KollabTextViewerHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('KollabTextViewer: container not found:', containerId);
    return {
      type: 'text',
      unmount: () => {},
      get api() { return null; },
    };
  }

  const apiRef = createRef<KollabTextViewerAPI>();
  const root = createRoot(container);
  root.render(React.createElement(KollabTextViewer, { ...props, ref: apiRef }));

  return {
    type: 'text',
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};

export type {
  KollabTextViewerProps,
  KollabTextViewerAPI,
  KollabTextViewerHandle,
};
